/* eslint-disable no-console */
<template>
<div>
    <div class="card z-depth-5 p-3">
        <h4 class="text-center font-weight-bold py-3">All Admins</h4>
        <div class="table-responsive">
            <table class="table table-bordered">
                <thead class="thead-dark">
                    <tr>
                        <th scope="col">Username</th>
                        <th scope="col">Permissions</th>
                        <th scope="col">Take Action</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(admin) in admins" :key="admin._id">
                        <td>{{admin.username}}</td>
                        <td>{{admin.permissions}}</td>
                        <td>
                            <router-link :to="{ name: 'EditAdmin', params : {user_id : admin._id} }">
                                <button class="btn btn-info btn-sm">Edit</button>
                            </router-link>
                            <button class="btn btn-red btn-sm" @click="changePassword(admin)">Change Password</button>

                        </td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
    <mdb-container>

        <mdb-modal :show="showPasswordModal" removeBackdrop position="middle">
          <button type="button" class="btn btn-danger btn-sm" data-dismiss="modal" @click="showPasswordModal = false">Close</button>
          <mdb-modal-body>
              <h4 class="text-center font-weight-bold py-3">Change Password</h4>
              <input
                type="text"
                ref="password"
                class="form-control mb-4"
                placeholder="Type Password"
              />
              <div class="modal-footer">
                  <button type="button" class="btn btn-info btn-sm" data-dismiss="modal" @click="updatePassword()">Update Password</button>
              </div>
          </mdb-modal-body>
        </mdb-modal>
    </mdb-container>
</div>
</template>

<script>
import axios from "axios"
import {
    mdbContainer,
    mdbModal,
    mdbModalBody
} from 'mdbvue';

export default {
    name: 'AddClassroom',
    components: {
        mdbContainer,
        mdbModal,
        mdbModalBody
    },
    data() {
        return {
            admins: [],
            admin: [],
            showPasswordModal: false,
            page: this.$route.params.page,
            fastAdminToken : localStorage.getItem("fastAdminToken")
        }
    },
    methods: {
        changePassword(admin) {
            this.admin = admin;
            this.showPasswordModal = true;
        },
        updatePassword() {
            if (this.$refs.password.value == "") {
                this.$toast.open({
                    message: "ERROR : Input Password",
                    type: "error",
                });
                return;
            }
            this.showPasswordModal = false;
            const config = {
                headers: {
                    Authorization: "Bearer " + this.fastAdminToken,
                    'Content-Type': 'application/json'
                }
            }

            let data = {
                user_id: this.admin._id,
                new_password: this.$refs.password.value
            };

            axios.post(this.$apiURI + "/account/adminpassword/update", data, config).then((response) => {
                if (response.data.error) {
                this.$toast.open({
                    message: "Error : " + response.data.message,
                    type: "error",
                });
                } else {
                this.$toast.open({
                    message: "Password Updated Successfully",
                    type: "success",
                });
                }
            })
            .catch((error) => {
                this.$toast.open({
                message: "Error : " + error.response.data.message,
                type: "error",
                });
            });
        },
    },

    mounted() {
        this.$toast.open({
            message: "Processing : Loading Teachers Please Wait...",
            type: 'info'
        })

        const config = {
            headers: {
                Authorization: "Bearer " + this.fastAdminToken,
                'Content-Type': 'application/json'
            }
        }
        axios.get(this.$apiURI + "/account/admins", config)
            .then((response) => {
                if (response.data.error) {
                    this.$toast.open({
                        message: "Error : " + response.data.message,
                        type: 'error'
                    });
                } else {
                    
                    // eslint-disable-next-line no-console
                    // console.log(response.data.data.teachers)
                    this.admins = response.data.data.admins
                }

            }).catch((error) => {
                this.$toast.open({
                    message: "Error : " + error.response.data.message,
                    type: 'error'
                });
            })
    }
}
</script>
